import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope, faExclamationTriangle,
  faNetworkWired, faArrowRightArrowLeft, faDownload, faCalendar,
  type IconDefinition,
} from "@fortawesome/free-solid-svg-icons";

export const parseDate = (dateStr?: string): number | null => {
  if (!dateStr) return null;
  // Handle .NET JSON date: /Date(1234567890000)/
  const dotNet = dateStr.match(/\/Date\((-?\d+)(?:[+-]\d+)?\)\//);
  if (dotNet) return parseInt(dotNet[1], 10);
  const d = new Date(dateStr).getTime();
  return isNaN(d) ? null : d;
};

export const timeAgo = (dateStr?: string): string => {
  const ts = parseDate(dateStr);
  if (ts === null) return "";
  const diff = Date.now() - ts;
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}hr ago`;
  const days = Math.floor(hrs / 24);
  return `${days}d ago`;
};

export const taskPriorityColor = (priority?: number) => {
  if (priority === 2) return { border: "border-l-red-500",    icon: "text-red-500",    accent: "#ef4444" };
  if (priority === 1) return { border: "border-l-yellow-400", icon: "text-yellow-500", accent: "#facc15" };
  return                      { border: "border-l-gray-400",  icon: "text-gray-400",  accent: "#9ca3af" };
};

export const notificationTypeColor = (sourceType?: number) => {
  switch (sourceType) {
    case 1:  return { border: "border-l-purple-500", icon: "text-purple-500", accent: "#a855f7" }; // Alert
    case 2:  return { border: "border-l-green-500",  icon: "text-green-500",  accent: "#22c55e" }; // Task
    case 6:  return { border: "border-l-red-500",    icon: "text-red-500",    accent: "#ef4444" }; // External
    case 8:  return { border: "border-l-orange-500", icon: "text-orange-500", accent: "#f97316" }; // Workflow
    case 10: return { border: "border-l-green-500",  icon: "text-green-500",  accent: "#22c55e" }; // Export
    default: return { border: "border-l-blue-500",   icon: "text-blue-500",   accent: "#3b82f6" }; // User/Message
  }
};

export const notificationTypeLabel = (sourceType?: number): string => {
  switch (sourceType) {
    case 1:  return "Alert";
    case 2:  return "Task";
    case 6:  return "External";
    case 8:  return "Workflow";
    case 10: return "Export";
    default: return "Notification";
  }
};

export const taskPriorityLabel = (priority?: number): string => {
  if (priority === 2) return "High priority task";
  if (priority === 1) return "Normal priority task";
  return "Task reminder";
};

export const NotificationIcon = ({ sourceType, className }: { sourceType?: number; className?: string }) => {
  let icon: IconDefinition;
  switch (sourceType) {
    case 1:  icon = faExclamationTriangle; break;
    case 2:  icon = faCalendar; break;
    case 6:  icon = faArrowRightArrowLeft; break;
    case 8:  icon = faNetworkWired; break;
    case 10: icon = faDownload; break;
    default: icon = faEnvelope;
  }
  return <FontAwesomeIcon icon={icon} className={className} aria-hidden />;
};
